<script>
  import { LmsUtils } from '../../../../../LMS/utils/LmsUtils';
  import { External } from '../../../../../external';

  export let activityType,
    data = {
      circleId: '',
      circleName: '',
      circleSettings: { requestAccess: { questions: [] } },
      accessRequest: { requestedAt: null, responses: {} }
    },
    contact;

  let clickHandler = async () => {
    let circles = await LmsUtils.listCircles();
    let circle = circles.find((circle) => circle.id === data.circleId);
    if (circle) {
      External.CPanel.goToUrl(`/me/community/circles/${circle.url}`);
    }
  };
</script>

<a class="blue-text" on:click={clickHandler}>
  {data.circleName}
</a>
{#if data.circleSettings.requestAccess.questions && data.circleSettings.requestAccess.questions.length > 0}
  <ul>
    {#each data.circleSettings.requestAccess.questions as question}
      {#if question}
        <li>{question.label} → <b>{data.accessRequest.responses[question.id]}</b></li>
      {/if}
    {/each}
  </ul>
{/if}
